// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"styles_tableHeader__1vI5P","clickable":"styles_clickable__2EvJh","sortIcon":"styles_sortIcon__rncPW"};